import { Accordion, AccordionItem } from '@apia/components';
import { Additional, Responsive, Sort } from '@apia/table';
import { Box } from '@apia/theme';

export const FiltersModal = ({ tableName }: { tableName: string }) => {
  return (
    <Box className="additionalFiltersContent">
      <Accordion className="filtersModals__accordion" singleExpand={true}>
        <AccordionItem
          id="Sortpanel"
          buttonProps={{
            ariaLabel: window.FINDER_ORDER_BY,
            label: window.FINDER_ORDER_BY,
          }}
          defaultExpanded
        >
          <Sort tableName={tableName} />
        </AccordionItem>
        <AccordionItem
          id="Filters"
          buttonProps={{
            ariaLabel: window.FINDER_FILTERS,
            label: window.FINDER_FILTERS,
          }}
        >
          <Responsive tableName={tableName} />
        </AccordionItem>
        <AccordionItem
          id="Additional"
          buttonProps={{
            ariaLabel: window.ADDITIONAL_FILTERS_LABEL,
            label: window.ADDITIONAL_FILTERS_LABEL,
          }}
        >
          <Additional tableName={tableName} />
        </AccordionItem>
      </Accordion>
    </Box>
  );
};
